// // dashboard-frontend/src/components/ProtectedRoute.jsx
// import React, { useEffect, useState } from 'react';
// import { Navigate } from 'react-router-dom';

// function ProtectedRoute({ children, roleRequired }) {
//   const [authorized, setAuthorized] = useState(false);
//   const [checked, setChecked] = useState(false);

//   useEffect(() => {
//     const checkAuth = () => {
//       let user = null;

//       // If this is a volunteer route, pull from 'volunteer' in localStorage
//       if (roleRequired === 'volunteer') {
//         const volunteerUser = localStorage.getItem('volunteer');
//         if (volunteerUser) {
//           user = JSON.parse(volunteerUser);
//         }
//       } else {
//         // Otherwise, assume an admin (or other roles) from 'dashboardUser'
//         const adminUser = localStorage.getItem('dashboardUser');
//         if (adminUser) {
//           user = JSON.parse(adminUser);
//         }
//       }

//       // Determine allowed roles
//       let allowedRoles;
//       if (Array.isArray(roleRequired)) {
//         allowedRoles = roleRequired;
//       } else if (roleRequired === 'admin') {
//         // Expand 'admin' to all admin-type roles
//         allowedRoles = ['master_admin', 'admin', 'accounts', 'trustee', 'graphics'];
//       } else {
//         allowedRoles = [roleRequired];
//       }

//       // Check if user is present + role is in allowed roles
//       if (user && allowedRoles.includes(user.role)) {
//         setAuthorized(true);
//       } else {
//         setAuthorized(false);
//       }
//       setChecked(true);
//     };

//     checkAuth();

//     // Re-check if the page is loaded from browser cache (e.g., back button)
//     const handlePageShow = (e) => {
//       if (
//         e.persisted ||
//         performance.getEntriesByType('navigation')[0].type === 'back_forward'
//       ) {
//         checkAuth();
//       }
//     };
//     window.addEventListener('pageshow', handlePageShow);

//     return () => {
//       window.removeEventListener('pageshow', handlePageShow);
//     };
//   }, [roleRequired]);

//   // Wait until the check is completed
//   if (!checked) return null;

//   // If not authorized, go Home ("/") instead of "/unauthorized"
//   if (!authorized) {
//     return <Navigate to="/" replace />;
//   }

//   return children;
// }

// export default ProtectedRoute;




// dashboard-frontend/src/components/ProtectedRoute.jsx
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children, roleRequired }) {
  const [authorized, setAuthorized] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      let user = null;

      // If route requires volunteer role, read from localStorage.volunteer
      if (roleRequired === 'volunteer') {
        const volunteerUser = localStorage.getItem('volunteer');
        if (volunteerUser) {
          user = JSON.parse(volunteerUser);
        }
      } else {
        // Otherwise, read from localStorage.dashboardUser
        const adminUser = localStorage.getItem('dashboardUser');
        if (adminUser) {
          user = JSON.parse(adminUser);
        }
      }

      // Expand or interpret roleRequired
      let allowedRoles;
      if (Array.isArray(roleRequired)) {
        allowedRoles = roleRequired;
      } else if (roleRequired === 'admin') {
        allowedRoles = ['master_admin', 'admin', 'accounts', 'trustee', 'graphics'];
      } else {
        allowedRoles = [roleRequired];
      }

      // Check if user has an allowed role
      if (user && allowedRoles.includes(user.role)) {
        setAuthorized(true);
      } else {
        setAuthorized(false);
      }
      setChecked(true);
    };

    checkAuth();

    const handlePageShow = (e) => {
      if (
        e.persisted ||
        performance.getEntriesByType('navigation')[0].type === 'back_forward'
      ) {
        checkAuth();
      }
    };
    window.addEventListener('pageshow', handlePageShow);

    return () => {
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, [roleRequired]);

  // Wait until we've done the auth check
  if (!checked) return null;

  // If not authorized, redirect to home page ("/")
  if (!authorized) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute;
